<template>
  <div>
    <div class="Paragraphs flex items-center justify-center">
      <div class="overflow-hidden">
        <div id="" class="flex flex-wrap mt-24 px-8 py-16 items-center justify-center wow bounceIn" data-wow-delay=".3s">
            
            <div class="w-full md:w-1/2 flex flex-col pt-0" :class="$i18n.locale == 'en' ? 'md:text-left':'md:text-right'">
              <div class="p-10 pt-0 pl-8 wow fadeInLeftBig" data-wow-duration="2s">
                <h1 class="w-full text-2xl md:text-3xl font-bold text-mytext-primary mb-4">{{ $t('paragraphs.paragraph1.title') }}</h1>
                <p class="tracking-wide w-full md:max-w-lg text-mytext-primary">
                     <strong class="text-lg tracking-tight">{{ $t('paragraphs.paragraph1.smTitle') }}</strong><br>
                     {{ $t('paragraphs.paragraph1.p1') }}
                </p><br>
                <p class="tracking-wide w-full md:max-w-lg text-mytext-primary"> {{ $t('paragraphs.paragraph1.p2') }} </p>
              </div> 
            </div>
            <div class="w-full md:w-1/2 max-w-md relative flex flex-col bg-cover rounded  transition-1 cursor-pointer overflow-hidden wow fadeInRightBig" data-wow-duration="2s">
              <div class="absolute inset-0 h-full w-full bg-gradient opacity-0 hover:opacity-50 transition-1"></div>
              <img src="@/assets/img/lap2.webp" alt="" class="w-full h-full rounded ">
            </div>
  
        </div>
      </div>
    </div>

    <div class="Paragraphs flex items-center justify-center">
      <div class="overflow-hidden">
        <div id="" class="flex flex-wrap px-8 py-16 items-center justify-center wow bounceIn" data-wow-delay=".3s">
            
            <div style="height: 500px;" class="w-full md:w-1/2 max-w-md relative hidden md:flex flex-col bg-cover rounded  transition-1 cursor-pointer overflow-hidden wow fadeInRightBig" data-wow-duration="2s">
              <div class="absolute inset-0 h-full w-full bg-gradient opacity-0 hover:opacity-50 transition-1"></div>
              <img src="@/assets/img/Hash.jpg" alt="" class="w-full h-full rounded ">
            </div>
            
            <div class="w-full md:w-1/2 flex flex-col pt-0" :class="$i18n.locale == 'en' ? 'md:text-left':'md:text-right'">
              <div class="p-10 pt-0 pl-8 wow fadeInLeftBig" data-wow-duration="2s">
                <h1 class="w-full text-2xl md:text-3xl font-bold text-mytext-primary mb-4">{{ $t('paragraphs.paragraph2.title') }}</h1>
                <p class="tracking-wide w-full md:max-w-lg text-mytext-primary">
                     <strong class="text-lg tracking-tight"> {{ $t('paragraphs.paragraph2.smTitle') }} </strong><br>
                     {{ $t('paragraphs.paragraph2.p1') }}
                </p>
                <p class="tracking-wide w-full md:max-w-lg text-mytext-primary"> 
                  <br>{{ $t('paragraphs.paragraph2.p2') }}
                  <br>{{ $t('paragraphs.paragraph2.p3') }}
                  <br>{{ $t('paragraphs.paragraph2.p4') }}
                 </p>
              </div> 
            </div>

            <div style="height: 500px;" class="w-full md:hidden md:w-1/2 max-w-md relative flex flex-col bg-cover rounded  transition-1 cursor-pointer overflow-hidden wow fadeInRightBig" data-wow-duration="2s">
            <div class="absolute inset-0 h-full w-full bg-gradient opacity-0 hover:opacity-50 transition-1"></div>
              <img src="@/assets/img/Hash.jpg" alt="" class="w-full h-full rounded ">
            </div>
  
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Paragraphs',
  data() {
    return {
      
    }
  },
  computed: {
    langLocaleNow(){
      return this.$i18n.locale
    }
  },
  watch: {
    langLocaleNow(){
      Object.assign(this.$data,this.$options.data.call(this))
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>